export default __webpack_public_path__ + "static/qr-code-UAT-28fc3afc1b1dd765c04a8a5307550c0a.png";